export const TopRolesChart = ({ topRoles }) => {
  if (!topRoles?.length) {
    return (
      <div className="mt-10 rounded-xl border border-slate-200 bg-white p-6 lg:p-8">
        <h2 className="font-display text-2xl font-bold text-slate-900">
          Most common Primary roles
        </h2>
        <p className="mt-4 text-sm text-slate-500 italic">
          No assessments yet.
        </p>
      </div>
    );
  }

  const max = topRoles[0].count || 1;

  return (
    <div className="mt-10 rounded-xl border border-slate-200 bg-white p-6 lg:p-8">
      <h2 className="font-display text-2xl font-bold text-slate-900">
        Most common Primary roles
      </h2>
      <div className="mt-5 space-y-2">
        {topRoles.map((row, i) => {
          const pct = Math.round((row.count / max) * 100);
          return (
            <div key={row.role + i} className="flex items-center gap-4">
              <div className="w-48 text-sm text-slate-700 truncate font-medium">
                {row.role}
              </div>
              <div className="flex-1 h-2 rounded-full bg-slate-100 overflow-hidden">
                <div
                  className="h-full bg-slate-900"
                  style={{ width: `${pct}%` }}
                />
              </div>
              <div className="w-12 text-right text-sm font-mono text-slate-600">
                {row.count}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TopRolesChart;
